import { Controller } from "@hotwired/stimulus"

// Toute la ligne déplie son détail, pas seulement le chevron : viser une poignée de 20 px pour
// lire quatre dates est une cible inutilement petite, et le reste de la ligne ne fait rien
// d'autre.
//
// On relaie le clic vers le bouton, qui porte déjà le `data-bs-toggle` de Bootstrap : poser le
// toggle sur la ligne elle-même aurait cassé les liens qu'elle contient — le gestionnaire
// délégué de Bootstrap remonte au plus proche `[data-bs-toggle="collapse"]` et appelle
// `preventDefault()` dès que la cible est un <a>. « Voir plus » n'irait alors plus nulle part.
export default class extends Controller {
  static targets = ["toggle"]

  // Ce qui est déjà cliquable garde son clic : le lien mène au contrat, le bouton de copie
  // copie, le chevron se débrouille seul.
  static INTERACTIVE_SELECTOR = "a, button, input, label, select, textarea"

  open(event) {
    if (!this.hasToggleTarget) return
    if (event.target.closest(this.constructor.INTERACTIVE_SELECTOR)) return
    // Sélectionner une référence pour la recopier ne doit pas replier ce qu'on est en train
    // de lire.
    if (!window.getSelection()?.isCollapsed) return

    this.toggleTarget.click()
  }
}
